import { memo } from "react";
import styled, { css } from "styled-components";

const HEADER_BG_COLOR = "#dcdbc1";

const StyledTableHeading = styled.th`
  font-size: 14px;
  text-align: ${({ textalign }) => textalign || "left"};
  background: ${HEADER_BG_COLOR};
  color: #2d2d2d;
  padding: ${({ issticky }) => (issticky === "Yes" ? "0px" : "20px 16px")};
  margin: 0;
  top: 0;
  position: ${({ issticky }) => (issticky === "Yes" ? "sticky" : "static")};
  width: ${({ width }) => width || "auto"};
  min-width: 60px;

  font-family: "Trebuchet MS", "Lucida Sans", Arial;
  font-weight: 600;
  border-bottom: 1px solid #e2e8f0;

  cursor: pointer;
  user-select: none;
  transition: background 0.2s ease, color 0.2s ease;

  /* Enable line breaks */
  white-space: normal;
  word-break: break-word;
  overflow-wrap: anywhere;

  /* Sticky shadows & alignment */
  ${({ issticky, stickyalign }) =>
    issticky === "Yes" &&
    css`
      z-index: 3;
      ${stickyalign === "left"
        ? `left: 0; border-right: 2px solid #e2e8f0;`
        : `right: 0; border-left: 2px solid #e2e8f0;`}
      background: ${HEADER_BG_COLOR};
      box-shadow: 0 0 6px rgba(0, 0, 0, 0.06);
    `}

  /* ACTIVE SORT HIGHLIGHT */
  ${({ issorted }) =>
    issorted === "Yes" &&
    css`
      background: ${HEADER_BG_COLOR} !important;
      color: #1e293b;
    `}
`;

const StickyContainer = styled.section`
  ${({ stickyalign }) =>
    stickyalign === "left"
      ? `border-right: 1px solid #e2e8f0;`
      : `border-left: 1px solid #e2e8f0;`}

  ${({ isdummy }) =>
    isdummy === "Yes"
      ? `padding: 24px;` // increased height
      : `padding: 20px 16px;`}

  background: ${HEADER_BG_COLOR}; /* ensures sticky background matches header */

  /* ensure children wrap */
  display: flex;
  flex-direction: column;
  justify-content: center;
  word-break: break-word;
  overflow-wrap: anywhere;
`;

const TableHeading = memo(
  ({
    children,
    width,
    textAlign,
    isSticky = "No",
    stickyAlign = "left",
    isDummy = "No",
    isSorted = false,
    onClick = () => {},
  }) => (
    <StyledTableHeading
      issticky={isSticky}
      issorted={isSorted ? "Yes" : "No"}
      textalign={textAlign}
      stickyalign={stickyAlign}
      width={width}
      isdummy={isDummy}
      onClick={onClick}
    >
      {isSticky === "Yes" ? (
        <StickyContainer stickyalign={stickyAlign} isdummy={isDummy}>
          {children}
        </StickyContainer>
      ) : (
        children
      )}
    </StyledTableHeading>
  )
);

export default TableHeading;
